module.exports = __webpack_public_path__ + "static/img/icon-field-user.ca35a81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-field-user.svg
// module id = 1435
// module chunks = 0